import {v4 as uuid} from 'uuid'

export const createUuidChannelName = (name: string) =>
  `${name}-${uuid().slice(0, 4)}-channel`
